
import React from 'react';
import { Star } from 'lucide-react';

const TourOverview: React.FC = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            <div className="md:col-span-2">
              <h2 className="font-playfair font-bold text-2xl md:text-3xl mb-6 text-[#3E2723]">
                Explore the Gritty Past of NYC's Most Colorful Neighborhood
              </h2>
              <div className="prose prose-lg text-[#3E2723]/90 font-montserrat">
                <p className="mb-4">
                  The Lower East Side has always been a place where survivors thrive—and that includes its cats. This 1.5-mile walking tour through the neighborhood's historic streets reveals the gritty, heartwarming, and sometimes shocking tales of feline residents from the 1800s and early 1900s.
                </p>
                <p className="mb-4">
                  From tenement cats who became neighborhood legends to the felines who called the old theaters and saloons home, these stories paint a vivid picture of life in one of America's most famous immigrant neighborhoods. You'll discover how cats navigated the crowded streets, survived harsh winters, and became beloved fixtures in a community that knew how to fight for survival.
                </p>
                <p className="mb-4">
                  Led by expert guides with deep knowledge of both feline and neighborhood history, this tour combines social history with delightful cat stories that reveal the character of the Lower East Side in ways traditional tours miss.
                </p>
                
                <div className="bg-[#FAF2E8] p-4 rounded-lg border border-[#C58B65]/20 mb-4">
                  <p className="text-[#8B4513] font-medium">
                    <strong>Tour Note:</strong> Our tours focus on historical stories and are not cat-spotting safaris (though if we see a feline friend along the way, we'll consider it a purr-fect bonus!).
                  </p>
                </div>
              </div>
            </div>
            
            {/* Sticky Booking Card */}
            <div className="md:sticky md:top-24">
              <div className="bg-[#FAF2E8] p-6 rounded-lg border border-[#C58B65]/20 shadow-md">
                <h3 className="font-playfair font-bold text-xl mb-4 text-[#3E2723] text-center">
                  Book Your Spot
                </h3>
                <p className="text-center mb-4 text-[#3E2723]/80">
                  $40 per person
                </p>
                <div className="flex justify-center mb-4">
                  <div className="flex items-center">
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <span className="ml-2 text-sm text-[#3E2723]/80">
                      (98% 5-star reviews)
                    </span>
                  </div>
                </div>
                <a 
                  href="#book-now"
                  className="bg-[#D32F2F] text-white py-3 px-4 rounded font-montserrat font-semibold text-center block hover:bg-[#C62828] transition-colors"
                >
                  Check Available Dates
                </a>
                <p className="text-xs text-center mt-4 text-[#3E2723]/60">
                  Secure booking · Instant confirmation
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TourOverview;
